// Import your 10 custom avatar assets (note avatar10 uses .jpg)
import avatar1 from "../assets/Character1.png";
import avatar2 from "../assets/Character2.png";
import avatar3 from "../assets/Character3.png";
import avatar4 from "../assets/Character4.png";
import avatar5 from "../assets/Character5.png";
import avatar6 from "../assets/Character6.png";
import avatar7 from "../assets/Character7.png";
import avatar8 from "../assets/Character8.png";
import avatar9 from "../assets/Character9.png";

// Single source of truth array exported for the onboarding grid and app usage
export const AvatarsL = [
  { id: "Character1", src: avatar1 },
  { id: "Character2", src: avatar2 },
  { id: "Character3", src: avatar3 },
  { id: "Character4", src: avatar4 },
  { id: "Character5", src: avatar5 },
  { id: "Character6", src: avatar6 },
  { id: "Character7", src: avatar7 },
  { id: "Character8", src: avatar8 },
  { id: "Character9", src: avatar9 },
];

export const getAvatarUrl = (user) => {
  if (
    user?.avatar &&
    typeof user.avatar === "string" &&
    user.avatar.startsWith("Character")
  ) {
    const found = AvatarsL.find((item) => item.id === user.avatar);
    if (found) return found.src;
  }

  // 3. Fallback: Assign a deterministic custom avatar based on the user's ID or Name
  const seedString = String(
    user?.id || user?.uid || user?.name || "MeetlyUser"
  );

  let hash = 0;
  for (let i = 0; i < seedString.length; i++) {
    hash = seedString.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % AvatarsL.length;

  return AvatarsL[index].src;
};
